import parseDialogue from "../../util/parseDialogue";

export const JoanaC6 = parseDialogue(`
joana:c6:100-200

#100 Well done, agent. You have accomplished your task, and I am happy to fulfill the terms of our agreement. Prepare to receive the software we promised.
>200 Ready to receive software transfer.
`);
